import * as types from '../../../../constants/ActionNameConstants';

export const newPasswordRequest = (payload) => {
  return {
    type: types.NEW_PASSWORD_REQUEST,
    payload,
  };
};

export const newPasswordSuccess = (payload) => ({
  type: types.NEW_PASSWORD_SUCCESS,
  payload,
});

export const newPasswordFailure = (error) => ({
  type: types.NEW_PASSWORD_FAILED,
  error,
});
